import React, { useEffect, useState } from 'react';
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardSubTitle, CardTitle, } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import '../../../../pages/documentation/charts/chart-columns/custom.scss';
import { getCourseDetails } from '../../../../services/master.service';
import { toasts } from '../../../../services/toast.service';
import useDarkMode from '../../../../hooks/useDarkMode';
import { getStudentAttendancePercentageByCourseId, getStudentTodayAttendanceReport } from '../../../../services/dashboard.service';
import { convertDateToEpoch, getCurrentDateAndTime } from '../../../../services/common.service';
import Chart from '../../../../components/extras/Chart';
import { TableLoader } from '../../../../services/loader.services';
import { useNavigate } from 'react-router-dom';

const AttendancePercentage = () => {

    useEffect(() => {
        getStudentTodayAttendanceReportList()
    }, [])

    const navigate = useNavigate();
    const [attendancePercentage, setAttendancePercentage] = useState<any>([]);
    const [dataStatus, setDataStatus] = useState(false)
    const [activeTab, setActiveTab] = useState('');
    const [dateView, setDateView] = useState('')


    function getStudentTodayAttendanceReportList() {
        setDataStatus(false);
        getStudentTodayAttendanceReport(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentTodayAttendanceReport;
                    if (data != undefined) {
                        setDataStatus(true);
                        setAttendancePercentage(data);
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                            // data[i].id = data[i].departmentId.toString();
                        }
                    } else {
                        setDataStatus(true);
                        toasts('Undefined Data', 'Error');
                    }
                } else if (response.data.success === false) {
                    setDataStatus(true);
                    // toasts(response.data.message, 'Error');
                    setAttendancePercentage([]);

                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    setDataStatus(true);
                    toasts(errorDescription, 'Error');
                }
            },
            (error) => {
                setDataStatus(true);
                toasts(error, 'Error');
            },
        );
    }


    return (
        <Card stretch className='rounded-1 border border-light'>
            <CardHeader borderSize={1}>
                <CardLabel icon='BarChart'>
                    <CardTitle tag='div' className='h5'>
                        Course Wise Attendance Summary
                    </CardTitle>
                </CardLabel>
                <CardActions>
                    <span className='h5 text-info p-3 fw-bold'>{dateView}</span>
                    {/* // <Button
                    // 	color='info'
                    // 	isLink
                    // 	icon='Summarize'
                    // 	onClick={handleOpenModal}>
                    // 	Details
                    // </Button> */}
                </CardActions>
            </CardHeader>

            <CardBody className=' d-flex align-items-center'>
                {attendancePercentage != '' ?
                    <div className='row' style={{ maxHeight: '60vh', overflow: 'scroll' }}>
                        <div className='col-xl-5 mt-2'>
                            <div className='row g-3'>
                                <div className='col-xl-12' >
                                    <Button
                                        size='sm'
                                        color='info'
                                        className='w-100 py-2'>
                                        Course
                                    </Button>
                                </div>
                                {attendancePercentage.map((company: any) => (
                                    <div key={company.courseId} className='col-xl-12' >
                                        <Button
                                            isLight={activeTab !== company.courseId}
                                            color='info'
                                            className='w-100 py-3'>
                                            {company.courseName}
                                        </Button>
                                    </div>

                                ))}
                            </div>
                        </div>
                        <div className='col-xl-7 mt-2'>
                            <div className='row g-3'>
                                <div className='col-xl-4' >
                                    <Button
                                        size='sm'
                                        color='dark'
                                        className='w-100 py-2'>
                                        Total Student
                                    </Button>
                                </div>
                                <div className='col-xl-4' >
                                    <Button
                                        size='sm'
                                        color='success'
                                        className='w-100 py-2'>
                                        Total Present
                                    </Button>
                                </div>
                                <div className='col-xl-4'>
                                    <Button
                                        size='sm'
                                        color='danger'
                                        className='w-100 py-2'>
                                        Total Absent
                                    </Button>
                                </div>
                                {attendancePercentage.map((company: any) => (
                                    <>
                                        <div className='col-xl-4'>
                                            {company.totalAbsent != 0 ?
                                                <Button
                                                    isLight
                                                    color='dark'
                                                    className='w-100 py-3'>
                                                    {company.totalStudents}
                                                </Button>
                                                : <Button
                                                    isLight
                                                    color='dark'
                                                    className='w-100 py-3'>
                                                    0
                                                </Button>}
                                        </div>
                                        <div className='col-xl-4' >
                                            {company.totalPresent != 0 ?
                                                <Button
                                                    isLight
                                                    color='success'
                                                    className='w-100 py-3'>
                                                    {company.totalPresent}
                                                </Button>
                                                : <Button
                                                    isLight
                                                    color='success'
                                                    className='w-100 py-3'>
                                                    0
                                                </Button>}
                                        </div>
                                        <div className='col-xl-4'>
                                            {company.totalAbsent != 0 ?
                                                <Button
                                                    isLight
                                                    color='danger'
                                                    className='w-100 py-3'>
                                                    {company.totalAbsent}
                                                </Button>
                                                : <Button
                                                    isLight
                                                    color='danger'
                                                    className='w-100 py-3'>
                                                    0
                                                </Button>}
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div> :
                    <TableLoader />}
            </CardBody>
        </Card>
    );
};

export default AttendancePercentage;